import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import { WalletIndexResourceModel } from '@/modules/wallet/models/wallet-resource.model'

export const adminUserTabularHeaderColumn = (user: WalletIndexResourceModel): TabularHeader['columns'] => [
  {
    name: 'id',
    title: 'شناسه کاربر',
    value: user.id
  },
  {
    name: 'username',
    title: 'نام کاربر',
    value: user.username
  },
  {
    name: 'displayname',
    title: 'نام و نام خانوادگی',
    value: user.displayname
  },
  {
    name: 'created_at',
    title: 'تاریخ عضویت',
    value: user.created_at
  },
  {
    name: 'last_login_at',
    title: 'آخرین فعالیت',
    value: user['last_login_at']
  },
  {
    name: 'wallet_amount',
    title: 'موجودی کاربر',
    value: user.wallet_amount.toLocaleString()
  },
  // {
  //   name: 'writer_wallet_amount',
  //   title: 'موجودی نویسنده',
  //   value: user.writer_wallet_amount.toLocaleString()
  // },
  {
    name: 'roles',
    title: 'نقش کاربری',
    value: user.roles.map(role => role.nickname).join('، ')
  },
  {
    name: 'actions',
    title: '',
    value: user.id
  }
]
